import { Progress } from 'antd';
import { useTranslation } from 'react-i18next';

interface TimerProgressProps {
  remainingTime: number;
  totalTime: number;
  isTimeoutReached: boolean;
}

/**
 * TimerProgress component
 *
 * @param {TimerProgressProps} props - The props for the TimerProgress component
 * @returns {Element} - The TimerProgress component
 */
function TimerProgress({ remainingTime, totalTime, isTimeoutReached }: TimerProgressProps) {
  const { t } = useTranslation();

  const getStrokeColor = () => {
    if (isTimeoutReached) return '#ff4d4f';

    const percentage = (remainingTime / totalTime) * 100;
    if (percentage > 66) return '#52c41a';
    if (percentage > 33) return '#fa8c16';

    return '#f5222d';
  };

  return (
    <>
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium">{t`Autosummary.timer.label`}</span>
        <span className="text-lg font-bold">{Math.max(0, remainingTime)}s</span>
      </div>
      <Progress
        className="mb-4"
        percent={Math.round((remainingTime / totalTime) * 100)}
        status={isTimeoutReached ? 'exception' : 'active'}
        showInfo={false}
        strokeColor={getStrokeColor()}
      />
    </>
  );
}

export default TimerProgress;
